import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';

import { UserFacade } from '@web/store/user/user.facade';
import { RouterFacade } from '@web/store/router/router.facade';

import { LogHttpService } from './log.http.service';
import { LogService } from './log.service';

import LogActions from './log.actions';

@Injectable()
export class LogEffects {
    private readonly actions$ = inject(Actions);
    private readonly userFacade = inject(UserFacade);
    private readonly routerFacade = inject(RouterFacade);
    private readonly logService = inject(LogService);
    private readonly logsHttpService = inject(LogHttpService);

    public readonly sendInvalidUserTariffLog$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LogActions.sendInvalidUserTariffLog),
                withLatestFrom(this.userFacade.user$, this.routerFacade.routerParams$),
                mergeMap(([, user, routerParams]) =>
                    this.logsHttpService
                        .sendLog(this.logService.getInvalidUserTariffLogMessage(user, routerParams))
                        .pipe(catchError(() => EMPTY))
                )
            ),
        { dispatch: false }
    );
}
